import React, {useState, useEffect} from 'react'
import {
	Box,
	Button,
	ButtonBase,
	Divider,
	IconButton,
	Input,
	List,
	ListItem,
	Modal,
	Typography,
	useMediaQuery,
	TextField,
} from '@mui/material'
import MpSvgIcon from '../atom/MpSvgIcon'
import DragAndDropFileUpload, {csvToArray,} from '../molecule/DragAndDropFileUpload'
import {
	ExpandMore as ExpandMoreIcon,
	ExpandLess as ExpandLessIcon,
	ArrowBack,
  } from '@mui/icons-material'
import readXlsxFile from 'read-excel-file'
import {useAppDispatch} from '../../../redux/storeExports'
import {CorporateActions, fetchUsers, postUserEmails} from '../../../redux/corporateService'
import closeicon from '@meprism/shared/src/assets/icons/successclose.png'
import Deleteicon from '@meprism/shared/src/assets/icons/Delete.svg'
import {ThemeProvider} from '@emotion/react'
import {fonts, theme} from '../../../config/Dashboardtheme'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useEmployeeProfileForm } from '../../../utils/hooks/useEmployeeProfileForm'
import MpTheme from '../../../config/MpTheme'
import LaunchIcon from '@mui/icons-material/Launch';
import EmployeeAuthLetterModal from './EmployeeAuthLetterModal'
import { Controller } from 'react-hook-form'
import { DatePicker ,LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { formatToSimpleDate, handleFlatData, parseDate } from '../../../utils/helpers'
import { profileSchema } from '@meprism/shared/src/schemas/EmployeeProfileForm'
const dataSchema = { firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    birthdate: '',
    mp_auth_letter_signature: '',
    address: {
      streetAddress: '',
      city: '',
      state: '',
      zip: ''
    }}
const validateEmail = (email: string) => {
	if (!email) {
		return false
	}
	// this beautiful construction is a classic from
	// https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
	return !!email.toLowerCase().match(
		// eslint-disable-next-line no-control-regex
		/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
	)
}

interface AddEmployeeModalProps {
	open: any
	isExecutive: boolean
}

const AddEmplyeesModal = (props: AddEmployeeModalProps) => {
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const defaultModalStyle = {
		position: 'absolute' as const,
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		bgcolor: 'background.paper',
		boxShadow: 24,
		p: 4,
		borderRadius: 5,
		paddingLeft: '50px',
		paddingRight: '50px',
		paddingTop: '30px',
		paddingBottom: '30px',
		maxHeight: '90vh',
		overflowY: 'auto',
		width: isMobile ? '90%' : '60%'
	}
	// const open = ModalOpenSelector()
	const dispatch = useAppDispatch()

	const handleClose = async() => {
		setVariant('fulfill');
		setEmails(['', '', ''])
		setUsersData([])
		setInvalidFileData([])
		setFile(null)
		setExpandedIndex(0)
		setAuthLetterError('')
		reset()
		dispatch(CorporateActions.setModalOpen(false));
		await dispatch(fetchUsers()).unwrap();
	}
	
	const [emails, setEmails] = useState(['','',''])
	const [file, setFile] = useState(null as any)
	const [usersData, setUsersData] = useState<any[]>([])
	const [expandedIndex, setExpandedIndex] = useState(0)
	const validEmails = emails.filter(validateEmail)
	const [variant, setVariant] = useState('fulfill')
	const isNewAdmin = props.isExecutive
	const [AuthLetterModalIndex, setAuthLetterModalIndex] = useState(-1)
	const [openAuthLetterModal, setOpenAuthLetterModal] = useState(false)
	const [invalidFileData, setInvalidFileData] = useState<any[]>([])
	const [authLetterError, setAuthLetterError] = useState('')

	const {
		register,
		control,
		submitHandler,
		profileFields,
		addProfile,
		remove,
		watch,
		errors,
		trigger,
		setValue,
		reset,
	  } = useEmployeeProfileForm({
	  middleNameOptional: true,
	  streetOptional: false,
	  linkedinOptional: true,
	  agreeToTermsOptional: false
	})
	
	useEffect(() => {
		if (props.open) {
		  reset();
		}
	  }, [props.open, reset]);
	  
	const profile = watch()

	const updateEmail = (email: string, index: number) => {
		const emailsCopy = emails.concat()
		emailsCopy[index] = email
		setEmails(emailsCopy)
	}

	const addData = async() => {
		
		setAuthLetterError('')
		
		if (isNewAdmin) {
			const lastIndex = profile.profiles.length -1
			const isValid = await trigger()
			const isConsentFormSigned =
      				!!profile?.profiles?.[lastIndex]?.mp_auth_letter_signature?.trim()

			if(isValid && isConsentFormSigned){
				setExpandedIndex(profile.profiles.length)
				addProfile()
				return
			}
			else if(!isConsentFormSigned){
				setAuthLetterError('Must Sign Authorization Letter before proceeding')
				return
			}

		}
		const emailsCopy = emails.concat()
		emailsCopy.push('')
		setEmails(emailsCopy)
	}
	
	const removeEmail = (index: number) => {
		const emailsCopy = emails.concat()
		emailsCopy.splice(index, 1)
		setEmails(emailsCopy)
	}

	const closeAuthLetterModal = () => {
		setOpenAuthLetterModal(false)
		setAuthLetterModalIndex(-1)
	  }
	  
	  const handleSaveSignature = (signature: string, index: number) => {
		setValue(`profiles.${index}.mp_auth_letter_signature`, signature)
		if(signature){
			setAuthLetterError('')
		}else{
			setAuthLetterError('Must Sign Authorization Letter before proceeding')
		}
	  }
	
	const onSubmit = (fileToRead: any) => {
		if (file === null) {
			setVariant('confirm')
		} else if (file.type === 'text/csv') {
			const reader = new FileReader()

			reader.addEventListener('loadend', function () {
				// reader.result contains the contents of blob as a typed array
				// we insert content of file in DOM here
				const rawData = reader.result
				const data = csvToArray(rawData as string)
				setEmails(data)
				
				setVariant('confirm')
			})
			
			reader.readAsText(fileToRead)
		} else if (
			file.type ===
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		) {
			
			readXlsxFile(fileToRead)
				.then((rows) => {
					const tempEmails = rows.map((row) => row.join().replace(/,/g, ''))
					setEmails(tempEmails as string[])
					
					setVariant('confirm')
				})
				.catch(() => {
					//emails will be empty, so we get the error message
					
					setVariant('confirm')
				})
		}
	}
	
	const onSubmitAdminPII = async(fileToRead: File) => {
		setUsersData([])
		setInvalidFileData([])
		if (fileToRead === null) {
			setAuthLetterError('')
			const lastIndex = profile.profiles.length -1
			const isValid = await trigger()
			const isConsentFormSigned =
      				!!profile?.profiles?.[lastIndex]?.mp_auth_letter_signature?.trim()

			if (isValid && isConsentFormSigned) {
				setUsersData(profile.profiles)
			  	setVariant('confirm')
			} 
			else if(!isConsentFormSigned){
				setAuthLetterError('Must Sign Authorization Letter before proceeding')
			}
			
			return
		}
		const isCSV = fileToRead.type === 'text/csv'
		const isXLSX =
  		fileToRead.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

		const flatKeys = [
		'email',
		'firstName',
		'middleName',
		'lastName',
		'linkedIn',
		'birthdate',
		'mp_auth_letter_signature',
		'streetAddress',
		'city',
		'zip',
		'state'
		]

		const addressKeys = ['streetAddress', 'city', 'state', 'zip']

		const mapRowToUserData = (header: string[], row: string[], index: number): any | null => {
			const userData = JSON.parse(JSON.stringify(dataSchema))


			header.forEach((key, i) => {
				const value = row[i]?.trim() || ''
	
				if (flatKeys.includes(key)) {
					// @ts-ignore
					userData[key] = value
				}
	
				if (addressKeys.includes(key)) {
				userData.address[key as keyof typeof userData.address] = value
				}
			})
	
			userData.rowIndex = index
		  
			const profileShapedData = {
			  firstName: [{ value: userData.firstName }],
			  middleName: [{ value: userData.middleName ?? "" }],
			  lastName: [{ value: userData.lastName }],
			  otherFirstName: [{ value: '' }],
			  otherMaidenName: [{ value: '' }],
			  phoneNumber: [{ value: '' }],
			  email: [{ value: userData.email }],
			  birthdate: parseDate(userData.birthdate),
			  address: [{
				streetAddress: userData.address.streetAddress,
				city: userData.address.city,
				state: userData.address.state,
				zip: userData.address.zip,
			  }],
			  mp_auth_letter_signature: userData.mp_auth_letter_signature,
			  auth_letter_s3_key: '',
			  auth_letter_version: '',
			  gender: '',
			  linkedIn: userData.linkedIn || '',
			  agreeToTerms: true,
			}
		  
			const result = profileSchema.safeParse(profileShapedData)
		  
			if (!result.success) {
			  const missingFields: string[] = []
			  const ContainerFieldsKeys = ['firstname', 'lastname', 'middlename', 'zip', 'city', 'streetaddress', 'state'];

			  result.error.errors.forEach((e) => {
				const path = String(e.path).toLowerCase()
				const errorField = ContainerFieldsKeys.find(field => path.includes(field)) || path
				if(missingFields.every((value:string)=>value!=errorField)){
					missingFields.push(errorField)
					console.log("error: ",e.message)
					console.log(profileShapedData)
				}
			  })
			  const invalidUserData = { ...userData, missingFields }
			  setInvalidFileData((prev) => [...prev, invalidUserData])
			  return null
			}
		  
			return userData
		  }
		const parseAdminData = (rows: string[][]) => {
		const [headerRow, ...dataRows] = rows
		let index = 1
		return dataRows
			.map((row) => mapRowToUserData(headerRow, row, index++))
			.filter((u): u is NonNullable<typeof u> => u !== null)
		}

		if (isCSV) {
		const reader = new FileReader()
		

		reader.addEventListener('loadend', () => {
			const rawData = reader.result as string
			const rows = rawData
			.trim()
			.split(/\r?\n/)
			.map((line) => line.split(','))

			if (rows.length === 0) return
			setUsersData(parseAdminData(rows))
			
			setVariant('confirm')
		
		})

		reader.readAsText(fileToRead)
		} else if (isXLSX) {
		
		readXlsxFile(fileToRead)
			.then((rows: any[][]) => {
			if (rows.length === 0) return
			setUsersData(parseAdminData(rows))
			
			
			setVariant('confirm')
			})
			.catch(() => {
			
			setVariant('confirm')
			})
		}
	}

	const handleRetry = () => {
		setVariant('fulfill');
		setEmails(['', '', ''])
		reset()
		setUsersData([])
		setInvalidFileData([])
		setExpandedIndex(0)
		setAuthLetterError('')
	}

	const handleBackPress = () =>{
		if(file){
			reset()
			setAuthLetterError("")
		}
		setVariant('fulfill')
	}

	const handleFinalSubmit = async () => {
		if(!isNewAdmin){
			await dispatch(postUserEmails(validEmails)).unwrap();
		}
		else if(isNewAdmin && file===null){
			submitHandler({'profiles': usersData})
		}
		else if (isNewAdmin && file) {
			const formattedCSVData: any[] = []
			usersData.forEach((userData) => {
				const { _missingFields, _rowIndex, ...cleanUserData } = userData
				formattedCSVData.push(handleFlatData(file,cleanUserData))
			  })
			submitHandler({'profiles': formattedCSVData})
		}
		handleClose();
	};

	const renderEmployeeData=(profileData:any, index:number)=>{
		return(
			<ListItem sx={{width:'100%', display:'flex', flexDirection:'column',marginBottom: '10px', justifyContent:'flex-start', alignItems:'flex-start', p:isMobile?0:3}} key={index}>
					<Typography variant={'caption'}>{`Employee ${index+1}`}</Typography>
						<Box sx={{width:'100%', display:'flex', flexDirection:'column'}}>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>Email: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}> {profileData.email[0]?.value}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>First Name: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}> {profileData.firstName[0]?.value}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>Middle Name: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}> {profileData.middleName[0]?.value}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>Last Name: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}> {profileData.lastName[0]?.value}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>City: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}>{profileData.address[0]?.city}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>State: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}>{profileData.address[0]?.state}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>Street Address: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}> {profileData.address[0]?.streetAddress}</Typography>
							</Box>
							
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>Zip: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}>{profileData.address[0]?.zip}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>LinkedIn: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}>{profileData.linkedIn}</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>Birthdate: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}>
									{formatToSimpleDate(profileData.birthdate)}
								</Typography>
							</Box>
							<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
								<Typography variant={'h5'}>Auth Letter Signature: </Typography>
								<Typography sx={{marginLeft: 1 }} variant={'h5'}>{profileData.mp_auth_letter_signature}</Typography>
							</Box>
							{
								(profileData.missingFields && profileData.missingFields.length > 0) &&
									<Box sx={{width:'100%', display:'flex', flexDirection:'row'}}>
										<Typography sx={{color:'red'}} variant={'h5'}>Invalid or missing fields:</Typography>
										<Typography sx={{ color: 'red', marginLeft:1}} variant={'h5'}>
											{profileData.missingFields.join(' , ')}
										</Typography>
									</Box>
							}
						</Box>
				</ListItem>
		)
	}

	const getBody = () => {
		if (variant === 'fulfill') {
			return (
				<>
					<ThemeProvider theme={theme}>
						<Box sx={defaultModalStyle}>
							<IconButton
								edge="end"
								color="inherit"
								onClick={handleClose}
								sx={{
									position: 'absolute',
									top: 10,
									right: 10,
									zIndex: 1, // Adjust the zIndex to make sure it's above other elements
									color: '#ffffff',
								}}>
								<img src={closeicon} style={{width: '42px'}}/>
							</IconButton>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}>
								<Typography
									variant={'h2'}
									sx={{font: fonts.Inter.Bold, color: '#1A1B20'}}>
									Add Employees
								</Typography>
							</Box>
							<Divider sx={{marginTop: '20px', marginBottom: '20px'}}/>
							<Box>
								<DragAndDropFileUpload
									file={file}
									setFile={(f: any) => setFile(f)}
								/>
							</Box>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									flexWrap: 'nowrap',
									marginTop: '20px',
									marginBottom: '20px',
								}}>
								<Divider sx={{flex: 1}}/>
								<Typography
									sx={{pl: '5px', pr: '5px'}}
									variant={'body3'}
									color={'#767676'}>
									*.csv or .xlsx (with one user data per line)
								</Typography>
								<Divider sx={{flex: 1}}/>
							</Box>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'start',
								}}>
								{!isNewAdmin && emails.map((email, index) => (
									<Box
										sx={{
											width: '100%',
											marginBottom: '10px',
											background: index % 2 === 0 ? '#C67EFF1A' : '#FFFFFF',
											p: 2,
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
										}}
										key={index}>
										<Box sx={{flex: 1}}>
											<Input
												key={index}
												value={emails[index]}
												onChange={(event) =>
													updateEmail(event.target.value, index)
												}
												placeholder={'employee@meprism.com'}
												sx={{
													'&.MuiInputBase-root': {
														'&.MuiInput-root::before': {
															content: 'none',
														},
													},
													borderRadius: '5px',
													border: '1px solid #A0A0A4',
													p: 3,
													flex: 1,
													fontFamily: fonts.Inter[300],
													fontSize: '16px',
													width: isMobile ? '90%' : '50%'
												}}
											/>
										</Box>
										{index !== 0 ? (
											<Box>
												<img
													src={Deleteicon}
													onClick={() => removeEmail(index)}
													style={{width: '20px'}}
												/>
											</Box>
										) : (<Box ml='20px'></Box>)}
									</Box>
								))}

								{isNewAdmin && profileFields.map((_:any, index:number) => (
									<Box
										sx={{
											width: '100%',
											mb: '10px',
											background: '#FFFFFF',
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'flex-start',
											borderTop: index!=0? '1px solid #ededed':'none',
											py: 3
										}}
										key={index}>
											<Box sx={{width:'100%', display:'flex', flexDirection: 'row',
											alignItems: 'center', justifyContent:'space-between'}}>
												<Typography variant={'h4'} sx={{my: 2}}>
													Employee {index+1}
												</Typography>
												{index !== 0 && (
													<ButtonBase sx={{paddingRight: 3}}>
														<DeleteOutlineIcon
															color='error'
															onClick={() => remove(index)}
														/>
													</ButtonBase>
												)}
											</Box>
											<Box
											sx={{
												width: '100%',
												display: 'flex',
												flexDirection: isMobile ? 'column' : 'row',
												alignItems: isMobile ? 'flex-start' : 'center',
												justifyContent: 'space-between',
												gap: 2,
											}}
											>
										
											<Box sx={{display:'flex', flexDirection:'column',  width: isMobile ? '100%' : '46%'}} >
											<Typography sx={{my: 2}} variant="h5">
												Email
											</Typography>
											<TextField
												autoComplete='disable'
												{...register(`profiles.${index}.email.0.value`)}
												error={!!errors.profiles?.[index]?.email?.[0]?.value}
												helperText={errors.profiles?.[index]?.email?.[0]?.value?.message}
												onInput={() => {
													trigger(`profiles.${index}.email.0.value`)
												}}
												fullWidth
												variant="outlined"
												placeholder='employee@company.com *'
												InputLabelProps={{ shrink: true }}
												sx={{
													'& input': {
													p:0
													},
													'& .MuiOutlinedInput-root': {
														p:5,
														borderWidth: 0
													},
													'&.MuiTextField-root': {
																border: 'none',
																},
													backgroundColor:MpTheme.colors.white
												}}
												/>
											</Box>

											<ButtonBase
													onClick={() => expandedIndex === index? setExpandedIndex(-1) : setExpandedIndex(index)}
													sx={{width: isMobile?'63%':'20%', marginTop: isMobile? 2:0}}
													>
													<Typography variant={'h4'} color={'#426BF0'}>
														Additional Information
													</Typography>
													{
														expandedIndex === index?
														<ExpandLessIcon color='info'/>:
														<ExpandMoreIcon color='info'/>
													}
												</ButtonBase>
											</Box>
											{
												expandedIndex === index &&
												<Box sx={{width: !isMobile?'70%':'100%',display: 'flex', flexDirection: 'column', my:2}}>
													<Typography sx={{my: 2}} variant="h5">
														Name
													</Typography>
													<Box sx={{display:'flex', flexDirection: isMobile? 'column':'row', justifyContent: !isMobile?'space-between':'flex-start'}} >
														<Box sx={{display:'flex', flexDirection:'column', width: isMobile ? '100%' : '32%', mb: isMobile?2:0}}>
														<TextField
															autoComplete='disable'
															placeholder='First Name *'
															{...register(`profiles.${index}.firstName.0.value`)}
															error={!!errors.profiles?.[index]?.firstName?.[0]?.value}
															helperText={errors.profiles?.[index]?.firstName?.[0]?.value?.message}
															
															fullWidth
															sx={{
																'& input': {
																p:0,
																},
																'& .MuiOutlinedInput-root': {
																p:5,
																borderWidth: 0,
																},
																'&.MuiTextField-root': {
																border: 'none',
																},															
																backgroundColor:MpTheme.colors.white
															}}
														/>
														</Box>
														<Box sx={{display:'flex', flexDirection:'column',  width: isMobile ? '100%' : '32%', mb: isMobile?2:0}} >
														<TextField
															placeholder='Middle Name'
															{...register(`profiles.${index}.middleName.0.value`)}
															error={!!errors.profiles?.[index]?.middleName?.[0]?.value}
															helperText={errors.profiles?.[index]?.middleName?.[0]?.value?.message}
															
															fullWidth
															sx={{'& input': {
																p:0
																},
																'& .MuiOutlinedInput-root': {
																p:5,
																borderWidth: 0
																},
																'&.MuiTextField-root': {
																border: 'none',
																},
																backgroundColor:MpTheme.colors.white
															}}
														/>
														</Box>
														<Box sx={{display:'flex', flexDirection:'column',  width: isMobile ? '100%' : '32%', mb: isMobile?2:0}}>
														<TextField
															autoComplete='disable'
														 	placeholder='Last Name *'
															{...register(`profiles.${index}.lastName.0.value`)}
															error={!!errors.profiles?.[index]?.lastName?.[0]?.value}
															helperText={errors.profiles?.[index]?.lastName?.[0]?.value?.message}
															
															fullWidth
															sx={{'& input': {
																p:0
																},
																'& .MuiOutlinedInput-root': {
																
																p:5,
																borderWidth: 0
																},
																'&.MuiTextField-root': {
																border: 'none',
																},
																backgroundColor:MpTheme.colors.white
															}}
														/>
														</Box>
													</Box>
													<Typography sx={{my: 2}} variant="h5">
														Address
													</Typography>
													<Box sx={{display:'flex', flexDirection: isMobile? 'column':'row', justifyContent: !isMobile?'space-between':'flex-start'}}>
														<Box sx={{display:'flex', flexDirection:'column', width: isMobile ? '100%' : '32%', mb: isMobile?2:0}}>
														<TextField
															autoComplete='disable'
															placeholder='City *'
															{...register(`profiles.${index}.address.0.city`)}
															error={!!errors.profiles?.[index]?.address?.[0]?.city}
															helperText={errors.profiles?.[index]?.address?.[0]?.city?.message}
															
															fullWidth
															sx={{'& input': {
																p:0
																},
																'& .MuiOutlinedInput-root': {
																
																p:5,
																borderWidth: 0
																},
																'&.MuiTextField-root': {
																border: 'none',
																},
																backgroundColor:MpTheme.colors.white
															}}
														/>
														</Box>
														<Box sx={{display:'flex', flexDirection:'column',  width: isMobile ? '100%' : '32%', mb: isMobile?2:0}}>
														<TextField
															autoComplete='disable'
															placeholder='State *'
															{...register(`profiles.${index}.address.0.state`)}
															error={!!errors.profiles?.[index]?.address?.[0]?.state}
															helperText={errors.profiles?.[index]?.address?.[0]?.state?.message}
															fullWidth
															
															sx={{'& input': {
																p:0
																},
																'& .MuiOutlinedInput-root': {
																
																p:5,
																borderWidth: 0
																},
																'&.MuiTextField-root': {
																border: 'none',
																},
																backgroundColor:MpTheme.colors.white
															}}
														/>
														</Box>
														<Box sx={{display:'flex', flexDirection:'column',  width: isMobile ? '100%' : '32%', mb: isMobile?2:0}}>
														<TextField
															autoComplete='disable'
															placeholder='Zip Code *'
															{...register(`profiles.${index}.address.0.zip`)}
															error={!!errors.profiles?.[index]?.address?.[0]?.zip}
															helperText={errors.profiles?.[index]?.address?.[0]?.zip?.message}
															fullWidth
															
															sx={{'& input': {
																p:0
																},
																'& .MuiOutlinedInput-root': {
																
																p:5,
																borderWidth: 0
																},
																'&.MuiTextField-root': {
																border: 'none',
																},
																backgroundColor:MpTheme.colors.white,
															}}
														/>
														</Box>
													</Box>
													<Box sx={{display:'flex', flexDirection:'column', width: isMobile ? '100%' : '66%', mb: isMobile?2:0, mt:2}}>
													<TextField
															autoComplete='disable'
															placeholder='Street Address*'
															{...register(`profiles.${index}.address.0.streetAddress`)}
															error={!!errors.profiles?.[index]?.address?.[0]?.streetAddress}
															helperText={errors.profiles?.[index]?.address?.[0]?.streetAddress?.message}
															
															fullWidth
															sx={{'& input': {
																p:0
																},
																'& .MuiOutlinedInput-root': {
																
																p:5,
																borderWidth: 0
																},
																'&.MuiTextField-root': {
																border: 'none',
																},
																backgroundColor:MpTheme.colors.white
															}}
														/>
													</Box>
													<Typography sx={{my: 2}} variant="h5">
														LinkedIn
													</Typography>
													<TextField
															autoComplete='disable'
															placeholder='LinkedIn URL'
															{...register(`profiles.${index}.linkedIn`)}
															error={!!errors.profiles?.[index]?.linkedIn}
															helperText={errors.profiles?.[index]?.linkedIn?.message}
															
															fullWidth
															sx={{'& input': {
																p:0
																},
																'& .MuiOutlinedInput-root': {
																
																p:5,
																borderWidth: 0
																},
																'&.MuiTextField-root': {
																border: 'none',
																},
																backgroundColor:MpTheme.colors.white,
																width: isMobile ? '100%' : '66%',
																
															}}
														/>
													<Typography sx={{my: 2}} variant="h5">
														Birthdate
													</Typography>
													<Box sx={{display:'flex', flexDirection:'column', width: isMobile ? '100%' : '32%', mb: isMobile?2:0}}>
													<LocalizationProvider dateAdapter={AdapterDayjs}>
													<Controller
														name={`profiles.${index}.birthdate`}
														control={control}
														
														render={({ field }) => (
															<DatePicker
															value={field.value || null}
															onChange={(newValue: Date | null) => {
																field.onChange(newValue)
																trigger(`profiles.${index}.birthdate`)
															}}
															OpenPickerButtonProps={{ style: { color: '#6F8EF5' } }}
															renderInput={(params: any) => (
																<TextField
																style={{backgroundColor:MpTheme.colors.white,
																}}
																fullWidth
																{...params}
																error={!!errors.profiles?.[index]?.birthdate}
																helperText={errors.profiles?.[index]?.birthdate?.message}
																onBlur={async () => {
																	field.onBlur()
																}}
																sx={{'& input': {
																	p:0
																	},
																	'& .MuiOutlinedInput-root': {
																	
																	p:5,
																	borderWidth: 0
																	},
																	'&.MuiTextField-root': {
																	border: 'none',
																	},
																	backgroundColor:MpTheme.colors.white,
																	width: '100%',
																	
																}}
																
																/>
															)}
															/>
														)}
														/>
													</LocalizationProvider>	

												</Box>
												<ButtonBase
													onClick={() => {
														setAuthLetterModalIndex(index)
														setOpenAuthLetterModal(true)
													}}
													sx={{marginTop: 10, width: isMobile? '75%': '30%'}}
													>
													<Typography variant={'h4'} color={'#426BF0'} sx={{marginRight: 2}}>
														Sign Authorization Letter
													</Typography>
													<LaunchIcon color='info' fontSize='small'/>

												</ButtonBase>
											</Box>
											}
									</Box>
								))}
								{
									authLetterError &&
									<Typography variant={'h5'} color={'red'} mb={5} width={'100%'}>
										{authLetterError} 
									</Typography>
								}
								<ButtonBase
									onClick={() => addData()}
									sx={{marginTop: '10px'}}>
									<MpSvgIcon
										icon={'circlePlus'}
										style={{marginRight: '5px'}}
									/>
									<Typography variant={'h4'} color={'#426BF0'}>
										Add Another
									</Typography>
								</ButtonBase>
							</Box>

							<Divider sx={{marginTop: '20px', marginBottom: '20px'}}/>
							<Button
								sx={{p: 3, width: isMobile ? '100%' : '30%'}}
								onClick={() => isNewAdmin? onSubmitAdminPII(file) :onSubmit(file)}
								variant={'outlined'}
								disabled={false}>
								Save & Continue
							</Button>
							{openAuthLetterModal && AuthLetterModalIndex !== -1 && (
								<EmployeeAuthLetterModal
									open={openAuthLetterModal}
									onClose={closeAuthLetterModal}
									index={AuthLetterModalIndex}
									onSave={handleSaveSignature}
									currentAuthSignature={profile?.profiles?.[AuthLetterModalIndex]?.mp_auth_letter_signature?.trim()}
								/>
								)}
						</Box>
					</ThemeProvider>
				</>
			)
		} else {
			return (
				<Box sx={defaultModalStyle}>
						<Box sx={{display: 'flex', flexDirection: 'row'}}>
							{(isNewAdmin ? usersData.length > 0 : validEmails.length > 0)? (
								<>
								<IconButton
								edge="start"
								color="inherit"
								onClick={handleBackPress}
								sx={{
									position: 'absolute',
									top: 25,
									left: 14,
									zIndex: 1,
								}}
									>
									<ArrowBack/>
								</IconButton>
									<Typography
										variant={'h2'}
										sx={{
											font: fonts.Inter.Bold,
											color: '#1A1B20',
											marginRight: '5px',
										}}>
										Adding{'  '}
									</Typography>
									<Typography
										variant={'h2'}
										sx={{
											font: fonts.Inter.Bold,
											color: '#1A1B20',
											marginRight: '5px',
										}}>
										{' '}
										{isNewAdmin? usersData.length: validEmails.length}
										{'  '}
									</Typography>
									<Typography
										variant={'h2'}
										sx={{
											font: fonts.Inter.Bold,
											color: '#1A1B20',
										}}>
										Employee{usersData.length > 1? 's': ''}
									</Typography>
								</>
							) : (
								<Typography
									variant={'h2'}
									sx={{
										font: fonts.Inter.Bold,
										color: '#1A1B20',
										marginRight: '5px',
									}}>
									Did not find any Valid Employee data
								</Typography>
							)}
							<IconButton
								edge="end"
								color="inherit"
								onClick={handleClose}
								sx={{
									position: 'absolute',
									top: 10,
									right: 10,
									zIndex: 1,
									color: '#ffffff',
								}}
							>
								<img src={closeicon} style={{width: '42px'}}/>
							</IconButton>
						</Box>
						<Divider sx={{marginBottom: '10px', marginTop: '20px'}}/>
						<List
							sx={{
								maxHeight: '300px',
								overflow: 'auto',
							}}>
							{(isNewAdmin? usersData.length > 0: validEmails.length > 0)? (
								isNewAdmin? 
								<Box>
								{invalidFileData.length > 0 &&
								<List sx={{width:'100%', display:'flex', flexDirection:'column'}}>
										<Typography variant='h3' sx={{mb: 3}}>Invalid Employee Data</Typography>
										{
											invalidFileData.map((data,index)=>(
												renderEmployeeData(handleFlatData(file,data), index)
											))
										}
								</List>}
								{<List sx={{width:'100%', display:'flex', flexDirection:'column'}}>
										{file && <Typography variant='h3' sx={{mb: 3}}>Valid Employee Data</Typography>}
										{
											usersData.map((userData, index) => (
												renderEmployeeData(handleFlatData(file,userData), index)
											))
										}
								</List>}
								
								</Box>
								:validEmails.map((email) => (
									<ListItem sx={{marginBottom: '10px'}} key={email}>
										<Typography variant={'caption'}>{email}</Typography>
									</ListItem>
								))
								) : (
								<>
									<Typography variant={'h2'} sx={{mb: 4}}>
										Troubleshooting
									</Typography>
									<Typography
										variant={'body2'}
										sx={{fontFamily: fonts.Inter[600], mb: '5px'}}>
										A few things to try:
									</Typography>
									{isNewAdmin ?
										<ul>
											<li>
												<Typography variant={'body2'}>
													Ensure all fields are in the appropriate format
													<Typography variant='h5'>For example:</Typography>
													<Typography variant='h5'>Email: name@company.com</Typography>
													<Typography variant='h5'>LinkedIn: https://www.linkedin.com/your-profile</Typography>
													<Typography variant='h5'>Date: DD/MM/YYYY (Age must be in range 18-100)</Typography>
													<Typography variant='h5'>State: 2 Letter State Code</Typography>
												</Typography>
											</li>
											<li>
												<Typography variant={'body2'}>
													Confirm that all required fields are present in every row 
													<Typography variant='h5'>
													 Required fields would be: email, firstName, lastName, city, state, streetAddress, zip, birthdate, mp_auth_letter_signature												
													</Typography>
												</Typography>
											</li>
										</ul>
										:
										<ul>
											<li>
												<Typography variant={'body2'}>
													Ensure all email address are in the appropriate format:
													<i>name@company.com</i>
												</Typography>
											</li>
											<li>
												<Typography variant={'body2'}>
													Confirm that all email addresses are in one column in
													the spreadsheet you upload
												</Typography>
											</li>
										</ul>
									}
								</>
							)}
						</List>
						<Divider sx={{marginBottom: '20px', marginTop: '20px'}}/>
						{(isNewAdmin? usersData.length > 0 : validEmails.length > 0)? (
							<Button onClick={handleFinalSubmit}>Add Employees</Button>
						) : (
							<>
								<Button variant={'contained'} onClick={handleRetry}>
									Try Again
								</Button>
								<Button
									sx={{marginLeft: '5px'}}
									href={
										'https://meprism1.atlassian.net/servicedesk/customer/portal/1'
									}>
									Contact Support
								</Button>
							</>
						)}
				</Box>
			)
		}
	}

	return (
		<>
			{/* <Button
        disabled={!corporateCode}
        onClick={handleOpen}
        variant={'text'}
        sx={{
          marginLeft: '64px',
          marginTop: '32px',
          marginRight: '64px',
          marginBottom: '32px',
        }}>
        <MpSvgIcon
          icon={'invite'}
          width={'20px'}
          height={'20px'}
          style={{
            marginRight: '5px',
          }}
          color={corporateCode ? '#426BF0' : '#767676'}
        />
        Invite Employees
      </Button> */}
			<Modal
				open={props.open}
				onClose={handleClose}
				sx={{
					backdropFilter: 'blur(5px)',
				}}>
				{getBody()}
			</Modal>
		</>
	)
}

export default AddEmplyeesModal
